var _rect, _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWebPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 108,
    viewBox: "0 0 144 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 108,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37259 5.37258 0 12 0H132C138.627 0 144 5.37258 144 12V18.72H0V12Z",
    fill: "#AAAAAA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7999,
    cy: 9.35998,
    rx: 2.88,
    ry: 2.88,
    fill: "#FF847C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.88,
    cy: 9.35998,
    rx: 2.88,
    ry: 2.88,
    fill: "#FAD17B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9598,
    cy: 9.35998,
    rx: 2.88,
    ry: 2.88,
    fill: "#97E17E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9292 47.1089C56.4642 48.5459 56.5436 50.9552 55.1066 52.4902L43.5826 64.8L55.1066 77.1098C56.5436 78.6448 56.4642 81.0541 54.9292 82.4911C53.3942 83.9281 50.9849 83.8487 49.5479 82.3137L35.5879 67.402C34.2174 65.938 34.2174 63.662 35.5879 62.198L49.5479 47.2863C50.9849 45.7513 53.3942 45.6719 54.9292 47.1089Z",
    fill: "#DB627B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4324 47.1088C86.8974 48.5458 86.8179 50.9552 88.255 52.4902L99.779 64.7999L88.255 77.1097C86.8179 78.6447 86.8974 81.054 88.4324 82.4911C89.9674 83.9281 92.3767 83.8487 93.8137 82.3136L107.774 67.4019C109.144 65.938 109.144 63.6619 107.774 62.198L93.8137 47.2862C92.3767 45.7512 89.9674 45.6718 88.4324 47.1088Z",
    fill: "#DB627B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.136 46.3585C81.0854 47.1466 82.0269 49.3658 81.2388 51.3152L69.1825 81.1387C68.3944 83.0881 66.1752 84.0296 64.2258 83.2415C62.2764 82.4534 61.3349 80.2343 62.123 78.2848L74.1793 48.4614C74.9674 46.5119 77.1865 45.5705 79.136 46.3585Z",
    fill: "#DB627B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebPink);
export default __webpack_public_path__ + "static/media/icon_web_pink.397937915761275115da779adf7c111e.svg";
export { ForwardRef as ReactComponent };